<mat-slider [min]="0" [step]="1" [max]="max - 1" [value]="value" vertical invert (input)="debouncedSetImage($event)"></mat-slider>
